document.querySelectorAll('[data-pbb-savings]').forEach(function(el) {
  var price   = parseFloat(el.dataset.price) || 0;
  var mode    = 'car';

  // Bo running costs
  var BO_ELECTRIC_PER_MILE = 0.175 / 30; // ~17.5¢ per full charge / 30 mi range
  var BO_MAINT_MONTHLY     = 100 / 12;   // ~$100/yr after 2yr warranty (tires, brakes, misc)

  var state = {
    car:   { miles: 12, gas: 3.30, mpg: 26, maint: 0.10, parking: 120, insurance: 150, taxes: 500, evMode: false, electricity: 0.16, ev_eff: 3.5 },
    metro: { pass: 130 },
    uber:  { rides: 2, avg: 18 }
  };

  function getTransportMonthly(m) {
    m = m || mode;
    if (m === 'car') {
      var c = state.car;
      var fuel_per_mile = c.evMode
        ? (c.electricity / Math.max(0.1, c.ev_eff))
        : (c.gas / Math.max(1, c.mpg));
      return c.miles * 22 * (fuel_per_mile + c.maint) + c.parking + c.insurance + (c.taxes / 12);
    }
    if (m === 'metro') return state.metro.pass;
    return state.uber.rides * 22 * state.uber.avg;
  }

  function getBoMonthly() {
    // Bo covers your commute distance regardless of what mode you're comparing against
    var electricity = state.car.miles * 22 * BO_ELECTRIC_PER_MILE;
    return electricity + BO_MAINT_MONTHLY;
  }

  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  function fmtMonths(m) {
    return m < 24 ? m + '/mo' : (m / 12).toFixed(1) + '/yr';
  }
  function fmtMonthsFull(m) {
    return m < 24 ? m + (m === 1 ? ' month' : ' months') : (m / 12).toFixed(1) + ' years';
  }

  function calcAvgMonths() {
    var bo = getBoMonthly();
    var all = ['car', 'metro', 'uber'].map(function(m) {
      var net = getTransportMonthly(m) - bo;
      return net > 0 ? Math.ceil(price / net) : Infinity;
    }).filter(function(m) { return isFinite(m) && m <= 240; });
    return all.length ? Math.round(all.reduce(function(a, b) { return a + b; }, 0) / all.length) : Infinity;
  }

  function fillSlider(slider) {
    var min    = parseFloat(slider.min) || 0;
    var max    = parseFloat(slider.max) || 100;
    var thumbW = 30; // must match CSS thumb width — thumb = pill height so it IS the right cap
    var pill   = slider.closest('.pbb__sav-slider-pill') || slider;
    var w      = pill.offsetWidth || 1;
    var vPct   = (parseFloat(slider.value) - min) / Math.max(1, max - min);
    // Fill stops at thumb CENTER — straight cut hidden behind middle of grabber
    var px = thumbW / 2 + vPct * (w - thumbW);
    pill.style.setProperty('--pct', (px / w * 100).toFixed(2) + '%');
  }

  function countUp(el, to, money, decimals) {
    var from = parseFloat(el.dataset.prev) || 0;
    if (from === to) return;
    var dur   = 420;
    var start = performance.now();
    function step(t) {
      var k    = Math.min(1, (t - start) / dur);
      var ease = 1 - Math.pow(1 - k, 3);
      var val  = from + (to - from) * ease;
      if (decimals) {
        el.textContent = val.toFixed(decimals);
      } else {
        el.textContent = money ? '$' + Math.round(val).toLocaleString('en-US') : Math.round(val).toLocaleString('en-US');
      }
      if (k < 1) requestAnimationFrame(step); else el.dataset.prev = to;
    }
    requestAnimationFrame(step);
  }

  function update() {
    var monthly    = getTransportMonthly();
    var boMonthly  = getBoMonthly();
    var netMonthly = monthly - boMonthly;
    var months     = netMonthly > 0 ? Math.ceil(price / netMonthly) : Infinity;
    var fiveYr     = Math.max(0, netMonthly * 60 - price);

    // Update mode totals in assumption summaries
    el.querySelectorAll('[data-sav-mode-total]').forEach(function(span) {
      var m = span.dataset.savModeTotal;
      span.textContent = '~' + fmt(getTransportMonthly(m)) + '/mo';
    });

    // Update Bo cost display
    var boElecEl     = el.querySelector('[data-sav-bo-electric]');
    var boTotalEl    = el.querySelector('[data-sav-bo-total]');
    var boChargesEl  = el.querySelector('[data-sav-bo-charges]');
    var electricity  = boMonthly - BO_MAINT_MONTHLY;
    var chargesPerMo = (state.car.miles * 22) / 30;
    if (boElecEl)    boElecEl.textContent    = Math.round(electricity);
    if (boTotalEl)   boTotalEl.textContent   = fmt(boMonthly);
    if (boChargesEl) boChargesEl.textContent = chargesPerMo.toFixed(1);

    var permonthEl = el.querySelector('[data-sav-permonth]');
    var thenEl    = el.querySelector('[data-sav-then]');
    var fiveyrEl  = el.querySelector('[data-sav-5yr]');
    var funWrap   = el.querySelector('[data-sav-fun-wrap]');

    if (!isFinite(months) || months > 240) {
      if (permonthEl) permonthEl.textContent = '—';
      if (thenEl)    thenEl.textContent    = 'Increase your usage to see savings';
      if (funWrap)   funWrap.hidden = true;
    } else {
      if (permonthEl) permonthEl.innerHTML = fmt(netMonthly) + '<span class="pbb__sav-ro-unit">/mo</span>';
      if (thenEl)  thenEl.textContent  = 'Pays for itself in ' + fmtMonthsFull(months);

      if (funWrap) {
        funWrap.hidden = fiveYr <= 0;
        if (fiveyrEl) fiveyrEl.textContent = fmt(fiveYr);
        funWrap.querySelectorAll('[data-sav-fun]').forEach(function(card) {
          if (card.dataset.savFunType === 'sp500-5yr') {
            // FV of monthly annuity: invest netMonthly each month for 60 months at 10%/yr
            var r  = 0.10 / 12;
            var fv = netMonthly * (Math.pow(1 + r, 60) - 1) / r;
            countUp(card, Math.round(fv), true);
          } else if (card.dataset.savFunDecimal) {
            var n = parseFloat(card.dataset.savFun) || 1;
            countUp(card, fiveYr / n, false, parseInt(card.dataset.savFunDecimal));
          } else {
            var n = parseFloat(card.dataset.savFun) || 1;
            countUp(card, Math.floor(fiveYr / n), false);
          }
        });
      }
    }
  }

  // Init sliders
  el.querySelectorAll('[data-sav-input]').forEach(function(slider) {
    var key = slider.dataset.savInput;
    var val = parseFloat(slider.value) || 0;
    if (key === 'car')   state.car.miles  = val;
    if (key === 'metro') state.metro.pass = val;
    if (key === 'uber')  state.uber.rides = val;
    fillSlider(slider);

    slider.addEventListener('input', function() {
      val = parseFloat(slider.value) || 0;
      if (key === 'car')   state.car.miles  = val;
      if (key === 'metro') state.metro.pass = val;
      if (key === 'uber')  state.uber.rides = val;
      fillSlider(slider);
      var display = el.querySelector('[data-sav-display="' + key + '"]');
      if (display) display.textContent = Math.round(val);
      update();
    });
  });

  // Seed car defaults from HTML (schema values)
  var insuranceInp   = el.querySelector('[data-sav-assumption="car_insurance"]');
  var taxesInp       = el.querySelector('[data-sav-assumption="car_taxes"]');
  var electricityInp = el.querySelector('[data-sav-assumption="car_electricity"]');
  var evEffInp       = el.querySelector('[data-sav-assumption="car_ev_eff"]');
  if (insuranceInp)   state.car.insurance   = parseFloat(insuranceInp.value)   || 150;
  if (taxesInp)       state.car.taxes       = parseFloat(taxesInp.value)       || 500;
  if (electricityInp) state.car.electricity = parseFloat(electricityInp.value) || 0.16;
  if (evEffInp)       state.car.ev_eff      = parseFloat(evEffInp.value)       || 3.5;

  // Init assumption inputs
  el.querySelectorAll('[data-sav-assumption]').forEach(function(inp) {
    applyAssumption(inp.dataset.savAssumption, parseFloat(inp.value) || 0);
    inp.addEventListener('input', function() {
      applyAssumption(inp.dataset.savAssumption, parseFloat(inp.value) || 0);
      update();
    });
  });

  function applyAssumption(key, val) {
    if (key === 'car_gas')         state.car.gas         = val;
    if (key === 'car_mpg')         state.car.mpg         = Math.max(1, val);
    if (key === 'car_maint')       state.car.maint       = val;
    if (key === 'car_parking')     state.car.parking     = val;
    if (key === 'car_insurance')   state.car.insurance   = val;
    if (key === 'car_taxes')       state.car.taxes       = val;
    if (key === 'car_electricity') state.car.electricity = val;
    if (key === 'car_ev_eff')      state.car.ev_eff      = Math.max(0.1, val);
    if (key === 'uber_avg')        state.uber.avg        = val;
  }

  // EV / Fuel toggle
  el.querySelectorAll('[data-sav-fuel-mode]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isEv = btn.dataset.savFuelMode === 'ev';
      state.car.evMode = isEv;
      el.querySelectorAll('[data-sav-fuel-mode]').forEach(function(b) {
        b.classList.toggle('is-active', b === btn);
      });
      el.querySelectorAll('[data-sav-field-mode]').forEach(function(row) {
        row.hidden = row.dataset.savFieldMode !== btn.dataset.savFuelMode;
      });
      update();
    });
  });

  // Tab switching
  el.querySelectorAll('[data-sav-mode]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      mode = btn.dataset.savMode;
      el.querySelectorAll('[data-sav-mode]').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      el.querySelectorAll('[data-sav-panel]').forEach(function(p) { p.hidden = p.dataset.savPanel !== mode; });
      // Recalculate fill now that the panel is visible (offsetWidth was 0 when hidden)
      var activePanel = el.querySelector('[data-sav-panel="' + mode + '"]');
      if (activePanel) activePanel.querySelectorAll('[data-sav-input]').forEach(fillSlider);
      update();
    });
  });

  // Smooth <details> accordion animation — uses .is-open class for icon toggling
  function smoothDetails(det) {
    var sum  = det.querySelector(':scope > summary');
    var body = sum && sum.nextElementSibling;
    if (!body) return;
    sum.addEventListener('click', function(e) {
      e.preventDefault();
      if (det.open) {
        body.style.overflow   = 'hidden';
        body.style.height     = body.offsetHeight + 'px';
        body.style.transition = '';
        requestAnimationFrame(function() {
          body.style.transition = 'height 0.28s ease';
          body.style.height     = '0';
          body.addEventListener('transitionend', function done(e) {
            if (e.propertyName !== 'height') return;
            body.removeEventListener('transitionend', done);
            det.open = false;
            det.classList.remove('is-open');
            body.style.cssText = '';
          });
        });
      } else {
        det.open = true;
        det.classList.add('is-open');
        var h = body.offsetHeight;
        body.style.overflow   = 'hidden';
        body.style.height     = '0';
        body.style.transition = '';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            body.style.transition = 'height 0.28s ease';
            body.style.height     = h + 'px';
            body.addEventListener('transitionend', function done(e) {
              if (e.propertyName !== 'height') return;
              body.removeEventListener('transitionend', done);
              body.style.cssText = '';
            });
          });
        });
      }
    });
  }
  el.querySelectorAll('details:not(.pbb__sav-assump)').forEach(smoothDetails);

  // Fixed average teaser — computed once from defaults, never changes
  var teaserEl = el.querySelector('[data-sav-teaser-months]');
  if (teaserEl) {
    var avg = calcAvgMonths();
    teaserEl.textContent = isFinite(avg) ? fmtMonths(avg) : '—';
  }

  update();

  // Recalculate fill positions if container width changes
  window.addEventListener('resize', function() {
    el.querySelectorAll('[data-sav-input]').forEach(fillSlider);
  });
});
